import axiosInstance from "./AxiosInstance";

export function getCompanyNewsLetterList(data) {
  return axiosInstance.post(`/company-subscribe-list`, data);
}

export function exportCompanyNewsLetterList(data) {
  return axiosInstance.post(`/company-subscribe-export`, data);
}
